import { Observable } from 'rxjs/Observable';
import type { StateEpic } from './types';

export const dummyEpic: StateEpic = () => Observable.empty();
